"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var useState = React.useState,
    useEffect = React.useEffect;

var camelToHyphen = function camelToHyphen(str) {
  return str.replace(/[A-Z]/g, function (m) {
    return "-" + m.toLowerCase();
  }).toLowerCase();
};

var objectToString = function objectToString(query) {
  if (typeof query === 'string') return query;
  return Object.entries(query).map(function (_a) {
    var feature = _a[0],
        value = _a[1];
    feature = camelToHyphen(feature);

    if (typeof value === 'boolean') {
      return value ? feature : "not " + feature;
    }

    if (typeof value === 'number' && /[height|width]$/.test(feature)) {
      value = value + "px";
    }

    return "(" + feature + ": " + value + ")";
  }).join(' and ');
};

exports.useMedia = function (rawQuery, defaultState) {
  if (defaultState === void 0) {
    defaultState = false;
  }

  var _a = useState(defaultState),
      state = _a[0],
      setState = _a[1];

  var query = objectToString(rawQuery);
  useEffect(function () {
    var mounted = true;
    var mql = window.matchMedia(query);

    var onChange = function onChange() {
      if (!mounted) return;
      setState(!!mql.matches);
    };

    mql.addListener(onChange);
    setState(mql.matches);
    return function () {
      mounted = false;
      mql.removeListener(onChange);
    };
  }, [query]);
  return state;
};

exports.default = exports.useMedia;